import { Divider, Tooltip } from '@heroui/react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import React, { FC, Fragment } from 'react';
import { ReactSVG } from 'react-svg';

import shortLogo from '../../../assets/images/short-hs-logo.svg?url';
import { useLocalStorage } from '../../../hooks';
import { MenuItemProps } from '../../../types';
import { Flex } from '../../Flex';
import { Icon } from '../../Icon';
import { Logo } from '../../Logo';
import {
  ButtonCollapse,
  MenuItemsWrapper,
  MenuLink,
  MenuLinkIcoWrapper,
  MenuLinkText,
  MenuLinkWrapper,
  SidebarLogoWrapper,
  SidebarWrapper,
} from './Sidebar.styled';

export interface SidebarProps {
  menuConfig?: MenuItemProps[];
  showMobile?: boolean;
  setShowMobile: (isOpen: boolean) => void;
}

export const Sidebar: FC<SidebarProps> = ({ menuConfig, showMobile, setShowMobile }) => {
  const [isCollapsed, setIsCollapsed] = useLocalStorage(
    'isMenuCollapsed',
    true,
  );

  const handleCollapseClick = () : void => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <SidebarWrapper collapsed={isCollapsed || false} isMobileMenuOpen={showMobile}>
      <div>
        <SidebarLogoWrapper>
          {isCollapsed ? (
            <Flex itemAlign="center" justifyContent="center">
              <ReactSVG src={shortLogo} shapeRendering={1} />
            </Flex>
          ) : (
            <Logo />
          )}

          {showMobile && <X size={24} color="#000" onClick={() => setShowMobile(false)} />}

          <ButtonCollapse onClick={handleCollapseClick}>
            {isCollapsed ? (
              <ChevronRight size={14} />
            ) : (
              <ChevronLeft size={14} />
            )}
          </ButtonCollapse>
        </SidebarLogoWrapper>
        <MenuItemsWrapper>
          {menuConfig
            ? menuConfig.map((menuItem: MenuItemProps) => (
              <Fragment key={`menu-${menuItem.pathName}`}>
                <MenuLink
                  key={`Item-${menuItem.pathName}`}
                  {...(menuItem.isExternal
                    ? {
                      as: 'a',
                      href: menuItem.path,
                      target: '_blank',
                      rel: 'noopener noreferrer',
                    }
                    : { to: menuItem.path })}
                >
                  {/* Rozwinięte menu jest tekstowe — nazwa pozycji niesie całą treść,
                      a ikona tylko dokładała szumu. W trybie ZWINIĘTYM ikona zostaje,
                      bo jest wtedy jedynym oznaczeniem pozycji (nazwa idzie w dymek). */}
                  <MenuLinkWrapper collapsed={isCollapsed}>
                    {isCollapsed ? (
                      <Tooltip
                        key={`tooltip-${menuItem.pathName}`}
                        color="secondary"
                        content={menuItem.pathName}
                        placement="right"
                      >
                        <MenuLinkIcoWrapper collapsed={isCollapsed}>
                          <Icon name={menuItem.icon} size={18} color="#000" />
                        </MenuLinkIcoWrapper>
                      </Tooltip>
                    ) : (
                      <MenuLinkText>
                        {menuItem.pathName}
                      </MenuLinkText>
                    )}
                  </MenuLinkWrapper>

                </MenuLink>

                {menuItem.hasDivider && (
                <Divider key={`divider-${menuItem.pathName}`} />
                )}
              </Fragment>
            ))
            : null }
        </MenuItemsWrapper>

      </div>
    </SidebarWrapper>
  );
};
